export default __webpack_public_path__ + "static/media/itinerary-sent.b50d393e.gif";